import React, { useState } from 'react';
import { apis, models } from '@vote4dance/judging-sdk';
import { _T } from "../../../../../base-react/src/Localization";
import { App, Button, Form, InputNumber, Modal, notification } from 'antd';
import { OrderedListOutlined } from '@ant-design/icons';
var Api = apis.Api;
var CompetitionsSource = models.competitions.CompetitionsSource;
export const ScheduleAssignBeats = (props) => {
    const { event_id, selection, disabled } = props;
    const { modal } = App.useApp();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
            setLoading(true);
            const roundIds = selection.map(round => round.round_id);
            Api.call(`${CompetitionsSource.url}/${event_id}`, "assign-beats-selection", { rounds: roundIds, start: values['start'] })
                .then(() => {
                setLoading(false);
                setIsModalOpen(false);
                form.resetFields();
            })
                .catch((err) => {
                notification.error({
                    message: err.name
                });
                setLoading(false);
                form.resetFields();
            });
        });
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handleClear = () => {
        modal.confirm({
            title: _T('common.delete.title', { name: _T('round.details.round_beat.label').toLowerCase() }),
            content: _T('common.delete.content', { name: _T('round.details.round_beat.label').toLowerCase() }),
            onOk() {
                setLoading(true);
                const roundIds = selection.map(round => round.round_id);
                Api.call(`${CompetitionsSource.url}/${event_id}`, "clear-beats-selection", { rounds: roundIds })
                    .then(() => {
                    setLoading(false);
                    setIsModalOpen(false);
                })
                    .catch((err) => {
                    notification.error({
                        message: err.name
                    });
                    setLoading(false);
                });
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: showModal, disabled: disabled || selection.length == 0, icon: React.createElement(OrderedListOutlined, null) }, _T('round.assignBeats.label')),
        React.createElement(Modal, { title: _T('round.assignBeats.label'), open: isModalOpen, onOk: handleOk, onCancel: handleCancel, confirmLoading: loading, footer: [
                React.createElement(Button, { key: "clear", type: "dashed", onClick: handleClear, danger: true, disabled: disabled }, _T('round.assignBeats.clear')),
                React.createElement(Button, { key: "back", onClick: handleCancel }, _T('common.cancel.title')),
                React.createElement(Button, { key: "submit", type: "primary", loading: loading, onClick: handleOk, disabled: disabled }, _T('common.ok'))
            ] },
            React.createElement(Form, { form: form, layout: "vertical", name: "assignBeatsForm", disabled: disabled, initialValues: { start: 1 } },
                React.createElement(Form.Item, { name: "start", label: _T('round.assignBeats.start'), rules: [{ required: true, message: _T('round.assignBeats.message') }] },
                    React.createElement(InputNumber, { min: 1 }))))));
};
